import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Typography } from 'antd'

const { Text, Title } = Typography

export const NoPhysiciansFoundMessage = () => {
  return (
    <div className='justify-center items-center py-8 px-0 md:px-12 lg:py-0'>
      <div className='flex flex-col md:flex-row'>
        <FontAwesomeIcon
          icon='exclamation-triangle'
          className='text-3xl text-[#a8071a]'
        />
        <div className='flex flex-col'>
          <div className='hidden md:inline'>
            <Title
              level={3}
              style={{ fontWeight: 400, paddingLeft: 8, color: '#a8071a' }}
            >
              Based on your search, there are no Top Tier physicians in your
              mile radius.
            </Title>
          </div>
          <div className='inline md:hidden'>
            <Title
              level={4}
              type='danger'
              style={{ fontWeight: 400, paddingLeft: 8, color: '#a8071a' }}
            >
              Based on your search, there are no Top Tier physicians in your
              mile radius.
            </Title>
          </div>
          <Text
            type='secondary'
            style={{
              fontWeight: 400,
              marginTop: 0,
              paddingLeft: 8,
            }}
          >
            Please increase the mile radius or revert back to your health
            insurance directory.
          </Text>
        </div>
      </div>
    </div>
  )
}
